import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'gatsby'
import classNames from 'classnames'
import * as styles from '../../styles/layout/nav.module.scss'

class MenuItem extends Component {
  constructor (props) {
    super(props)

    this.ref = React.createRef()
    this.subnavRef = React.createRef()

    this.state = {
      rect: {}
    }
  }

  render () {
    const childStyles = {}

    if (this.ref.current && this.subnavRef.current) {
      const { right, left } = this.ref.current.getBoundingClientRect()

      const subnavItems = this.subnavRef.current.querySelectorAll('li')
      let subnavWidth = 0

      for (const item of subnavItems) {
        subnavWidth += item.offsetWidth
      }

      const itemMidpoint = left + ((right - left) / 2)
      let subnavPosition = itemMidpoint - (subnavWidth / 2)

      if (subnavPosition + subnavWidth > this.props.windowWidth) {
        subnavPosition = this.props.windowWidth - subnavWidth
      }

      childStyles.paddingLeft = subnavPosition - 20 // calculations are correct but Chrome is wrapping when size is exact, remove 1px to accomodate
    }

    return (
      <li
        key={this.props.item.id}
        onMouseEnter={this.props.onMouseEnter.bind(this)}
        onMouseLeave={this.props.onMouseLeave.bind(this)}
        ref={this.ref}
        className={classNames({ [styles.menuItemActive]: this.props.active && this.props.item.children.length > 0, [styles.menuItem]: true })}
      >

        <Link
          to={'/' + this.props.item.page.slug}
          onClick={this.props.onClick}
        >
          {this.props.item.title}
        </Link>

        {this.props.item.children.length > 0 ? (
          <ul className={classNames({ [styles.subMenuActive]: this.props.active, [styles.subMenu]: true })} style={childStyles} ref={this.subnavRef}>
            {this.props.item.children.map(child => (
              <li key={child.id} className={classNames(styles.menuItem, styles.subMenuItem)}>
                <Link
                  to={'/' + this.props.item.page.slug + '/' + child.page.slug}
                  onClick={this.props.onClick}
                >
                  {child.title}
                </Link>
              </li>
            ))}
          </ul>
        ) : null}
      </li>
    )
  }
}

MenuItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    page: PropTypes.object,
    children: PropTypes.array,
    title: PropTypes.string
  }).isRequired,
  active: PropTypes.bool,
  windowWidth: PropTypes.number,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  location: PropTypes.object
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  windowWidth: state.global.windowWidth
})

export default connect(mapStateToProps)(MenuItem)
